import { ReduxStatus } from '../types';

const SET = 'status/SET';
const UNSET = 'status/UNSET';

export const setStatus = (
  payload: Partial<ReduxStatus>,
  /* istanbul ignore next */ type = SET,
) => ({
  type,
  payload,
  meta: { status: SET },
});

export const unsetStatus = (payload: any, type = UNSET) => ({
  type,
  payload,
  meta: { status: UNSET },
});

export const reducer = (state = {}, action: any) => {
  switch (action && action.meta && action.meta.status) {
    case SET:
      return Object.assign({}, state, action.payload);

    case UNSET: {
      const nextState = Object.assign({}, state);
      action.payload.forEach((key: any) => delete nextState[key]);
      return nextState;
    }

    default:
      return state;
  }
};
